export default {
  namespaced: true,
  state: {
    productToBuy: null,
  },
  getters: {
    mergeWithProduct(state, getters, rootState, rootGetters) {
      const findProductBy = rootGetters['product/findProductBy'];

      return (history) => history.map((item) => {
        const product = findProductBy('productCode', item.productCode);
        return { ...item, product };
      });
    },
  },
  mutations: {
    setProduct(state, item) {
      state.productToBuy = item;
    },
  },
  actions: {
    addToCart({ commit }, item) {
      commit('setProduct', item);
    },
    clearCart({ commit }) {
      commit('setProduct', null);
    },
    getPurchaseHistory({ dispatch, getters, rootGetters }, params) {
      const requests = [
        rootGetters.api.get('/purchases', { params }),
        dispatch('product/loadProducts', null, { root: true }),
      ];

      return Promise.all(requests)
        .then(([response]) => ({
          ...response.data,
          purchases: getters.mergeWithProduct(response.data.purchases),
        }));
    },
    buyMyMonitoring({ rootGetters }, params) {
      return rootGetters.api.post('/mon/subscribe/pay', params)
        .then((response) => response.data);
    },
    buyMyPaymentDefaults({ rootGetters }, params) {
      return rootGetters.api.post('/pd/send/pay', params)
        .then((response) => response.data);
    },
    buyReport({ rootGetters }, params) {
      return rootGetters.api.post('/report/pay', params)
        .then((response) => response.data);
    },
    promotionReport({ rootGetters }, params) {
      return rootGetters.api.post('/report/promotion', params)
        .then((response) => response.data);
    },
    freeReport({ rootGetters }, params) {
      return rootGetters.api.post('/report/free', params)
        .then((response) => response.data);
    },
    checkIsPromotionalReport({ rootGetters }, params) {
      return rootGetters.api.post('/report/promotion/status', {
        ...params,
        subjectCode: rootGetters['session/userId'],
      }).then((response) => response.data);
    },
    withdrawPurchase({ rootGetters }, params) {
      return rootGetters.api.post('/purchases/withdraw', params)
        .then((response) => response.data);
    },
  },
};
